import { useEffect } from 'react';
import { initializeUTMTracking } from '@/utils/utm-tracking';

const UTMTracker = () => {
  useEffect(() => {
    initializeUTMTracking();
  }, []);

  return null; // This component doesn't render anything
};

export default UTMTracker;